import axios from "axios";
import { API_BASE_URI } from "../constants/urls";
import { logout } from "../utils/utility";

const axiosInstance = axios.create({
  baseURL: API_BASE_URI,
  headers: {
    "x-api-key": "zR0ClHzLGi",
    "x-client":"liyubus admin",

  },
});

axiosInstance.interceptors.response.use(undefined, (error) => {
  if (error.status === 401) {
    logout();

    return Promise.reject(error);
  }
});

export default axiosInstance;
